import React from 'react';
import { theme, Box } from '@fiverr-private/theme';

interface CircularProgressProps {
  percentage: number; // number between 0 and 1
}

const containerSize = 32;
const radius = containerSize / 2;
const strokeWidth = 2;

const CircularProgress = ({ percentage }: CircularProgressProps) => {
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - percentage * circumference;

  return (
    <Box display="flex" position="absolute" width={containerSize} height={containerSize}>
      <Box
        as="svg"
        transform="rotate(-180deg)"
        top={0}
        left={0}
        position="absolute"
        height={radius * 2}
        width={radius * 2}
      >
        <Box
          as="circle"
          transition="stroke-dashoffset 0.35s"
          transform="rotate(90deg)"
          style={{ transformOrigin: 'center' }}
          stroke={theme.colors.grey_900}
          fill={theme.colors.transparent}
          strokeWidth={strokeWidth}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <Box
          as="circle"
          transition="stroke-dashoffset 0.35s"
          transform="rotate(90deg)"
          stroke={theme.colors.white}
          fill={theme.colors.transparent}
          strokeWidth={strokeWidth}
          strokeDasharray={`${circumference} ${circumference}`}
          style={{ strokeDashoffset, transformOrigin: 'center' }}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </Box>
    </Box>
  );
};

CircularProgress.displayName = 'CircularProgress';
export default CircularProgress;
